import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldsetComponent, InputComponent } from '@woolworthsnz/form';
import { NgClass, NgFor } from '@angular/common';

interface Option {
	text: string;
	value: string;
}

@Component({
	selector: 'dc-form-checkbox',
	templateUrl: './form-checkbox.component.html',
	styleUrls: ['./form-checkbox.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FieldsetComponent, NgClass, FormsModule, ReactiveFormsModule, NgFor, InputComponent],
})
export class FormCheckboxComponent {
	@Input() label: string;
	@Input() options: Option[];
	@Input() layout: 'vertical' | 'horizontal' = 'vertical';
	@Input() group: FormGroup;
	@Input() controlName: string;
	@Input() hideLegend: boolean;

	getLabel(i: number): string {
		return `${this.controlName}_${this.options[i].value}`;
	}
}
